import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import { Component, Input, OnInit, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
  standalone: false,
  selector: 'app-tab-main',
  templateUrl: './tab-main.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./tab-main.component.scss']
})
export class TabMainComponent implements OnInit, OnChanges {
  @Input() links: { routerLink: string, title: string, objectId?: string }[] = [];
  @Input() selectedIndex = 0;

  filteredLinks: { routerLink: string, title: string, objectId?: string }[] = [];

  constructor(
    private router: Router,
    private permissionService: PermissionService
  ) {}

  ngOnInit() {
    this.filterLinks();
    this.updateSelectedTab();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['links']) {
      this.filterLinks();
      this.updateSelectedTab();
    }
  }

  filterLinks() {
    this.filteredLinks = this.links.filter(link =>
      !link.objectId || this.permissionService.hasReadPermission(link.objectId)
    );
  }

  updateSelectedTab() {
    const currentUrl = this.router.url.split('?')[0];
    const currentIndex = this.filteredLinks.findIndex(link => {
      const linkSegments = link.routerLink.split('/');
      const urlSegments = currentUrl.split('/');
      return linkSegments.every((segment, i) => segment === urlSegments[i]);
    });
    if (currentIndex !== -1) {
      this.selectedIndex = currentIndex;
    }
  }

  onTabChange(index: number) {
    const selectedLink = this.filteredLinks[index];
    if (selectedLink) {
      this.router.navigate([selectedLink.routerLink]);
    }
  }

  public trackByIndex = trackByIndex;
}
